import { useRouter } from 'vue-router';
import { provide, ref, computed } from 'vue';
import "ant-design-vue/es/dropdown/style/css";
import _Dropdown from "ant-design-vue/es/dropdown";
import "ant-design-vue/es/menu/style/css";
import _Menu from "ant-design-vue/es/menu";
import "ant-design-vue/es/modal/style/css";
import _Modal from "ant-design-vue/es/modal";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-1f4d6356"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "name"
};
const _hoisted_3 = {
  class: "menu"
};
const _hoisted_4 = {
  class: "hand_box"
};
const _hoisted_5 = {
  class: "tool_box"
};
const _hoisted_6 = {
  class: "userInfo tabMenu"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", null, null, -1));
import NotificationList from '@/components/Notification.vue';
import { useStore } from 'vuex';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';
export default {
  __name: 'BasicLayout',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    // console.log(111)
    // getLoginUser().then(response => {

    store.dispatch("GetInfo").then(res => {}).catch(err => {
      console.log(err);
    });

    // }).catch(error => {
    // 		if (error.code = 401) {
    // 			window.location.replace('/#/login')
    // 			message.error('已经登录超时请重新登录')
    // 		}
    // })

    const menuArr = store.state.menuList;
    provide('menuList', menuArr);
    const collapsed = ref(false);
    const collapsedAction = () => {
      collapsed.value = !collapsed.value;
    };
    const selSystem = computed(() => [store.state.curSystem]);
    const apps = computed(() => {
      return store.state.apps;
    });
    const menuChange = type => {
      store.commit('changeSystem', type);
    };
    const setLangue = langue => {
      store.commit('setLangue', langue);
    };
    const OnUserClick = key => {
      console.log(key);
      if (key.key == "Logout") {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要退出登录吗?',
          onOk: () => {
            store.dispatch("Logout", store.state).then(res => {
              router.push('/login');
            });
          }
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_LeftMenu = _resolveComponent("LeftMenu");
      const _component_a_layout_sider = _resolveComponent("a-layout-sider");
      const _component_a_col = _resolveComponent("a-col");
      const _component_UserOutlined = _resolveComponent("UserOutlined");
      const _component_PoweroffOutlined = _resolveComponent("PoweroffOutlined");
      const _component_a_row = _resolveComponent("a-row");
      const _component_multi_tab = _resolveComponent("multi-tab");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      const _component_a_layout = _resolveComponent("a-layout");
      return _openBlock(), _createBlock(_component_a_layout, {
        class: "layout"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_layout_sider, {
          collapsed: collapsed.value,
          "onUpdate:collapsed": _cache[0] || (_cache[0] = $event => collapsed.value = $event),
          trigger: null,
          collapsible: "",
          collapsedWidth: 48,
          class: "layout-sider"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["info", {
              'collapsed_info': collapsed.value
            }])
          }, [_hoisted_1, !collapsed.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, " LtlApp")) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_3, [_createVNode(_component_LeftMenu, {
            collapsed: collapsed.value
          }, null, 8, ["collapsed"])]), _createElementVNode("div", _hoisted_4, [collapsed.value ? (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), {
            key: 0,
            onClick: collapsedAction
          })) : (_openBlock(), _createBlock(_unref(MenuFoldOutlined), {
            key: 1,
            onClick: collapsedAction
          }))])]),
          _: 1
        }, 8, ["collapsed"]), _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [_createVNode(_component_a_layout_content, {
            class: "layout-content",
            style: {
              "padding": "0px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              type: "flex"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                flex: "auto"
              }, {
                default: _withCtx(() => [_createVNode(_unref(_Menu), {
                  selectedKeys: _unref(selSystem),
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _isRef(selSystem) ? selSystem.value = $event : null),
                  mode: "horizontal",
                  theme: "dark"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(apps), item => {
                    return _openBlock(), _createBlock(_unref(_Menu).Item, {
                      key: item.code,
                      onClick: $event => menuChange(item.code)
                    }, {
                      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.name), 1)]),
                      _: 2
                    }, 1032, ["onClick"]);
                  }), 128))]),
                  _: 1
                }, 8, ["selectedKeys"])]),
                _: 1
              }), _createVNode(_component_a_col, {
                flex: "100px"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(_Dropdown), null, {
                  overlay: _withCtx(() => [_createVNode(_unref(_Menu), {
                    onClick: OnUserClick
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(_Menu).Item, {
                      key: "UserCenter"
                    }, {
                      icon: _withCtx(() => [_createVNode(_component_UserOutlined)]),
                      default: _withCtx(() => [_createTextVNode(" 个人中心 ")]),
                      _: 1
                    }), _createVNode(_unref(_Menu).Divider), _createVNode(_unref(_Menu).Item, {
                      key: "Logout"
                    }, {
                      icon: _withCtx(() => [_createVNode(_component_PoweroffOutlined)]),
                      default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("label", null, _toDisplayString(_unref(store).state.userInfo.name), 1)])]),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_multi_tab)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};